import type { PlanGeoData } from '../proposition-c/types';
import type { Project } from './types';
import type { CalculationSection } from './sectionEngine';
import { getResponse } from 'msw';
import { commandHandler } from './commandHandlers';
import { viewerFromSearch } from './permissions';

export interface LocalCommand {
  project: Project;
  planId?: string;
  section?: CalculationSection;
  geo?: PlanGeoData;
}

/**
 * Exécute le même handler MSW HTTP en mémoire via son API officielle.
 * Aucun fetch / XHR, aucun backend, aucune dépendance au contrôle SW du premier chargement.
 * Les headers, validations, délais et réponses 403/422 restent réellement exercés.
 */
export async function localCommand(command: LocalCommand): Promise<Project> {
  const response = await getResponse([commandHandler], new Request(
    new URL('/api/plan/navigation-projets/command', location.origin), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json',
        'X-Viewer': viewerFromSearch(location.search) },
      body: JSON.stringify(command),
    },
  ));
  if (!response) throw new Error('Handler MSW indisponible : aucune donnée appliquée.');
  const body: unknown = await response.json();
  if (!response.ok) throw new Error((body as { error?: string }).error ?? `Erreur ${response.status}`);
  return body as Project;
}
